import { render, staticRenderFns } from "./DialogAddCustomer.vue?vue&type=template&id=23f79e26&scoped=true"
import script from "./DialogAddCustomer.vue?vue&type=script&lang=js"
export * from "./DialogAddCustomer.vue?vue&type=script&lang=js"
import style0 from "./DialogAddCustomer.vue?vue&type=style&index=0&id=23f79e26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f79e26",
  null
  
)

export default component.exports